import { AppCardSkeleton, AppCardSkeletonMetaFooter } from '@app/components/base/app-card';

/**
 * One skeleton placeholder card matching FragmentCard layout for audio fragments.
 */
export function AudioFragmentCardSkeleton() {
  return <AppCardSkeleton media={{ height: 100 }} footer={<AppCardSkeletonMetaFooter />} />;
}
